export const DEFAULT_STOREFRONT_SETTINGS = {
    primaryColor: '#111111',
    accentColor: '#0f172a',
    backgroundColor: '#ffffff',
    cardColor: 'rgba(255, 255, 255, 0.75)',
    textColor: '#111111',
    textMutedColor: '#666666',
    borderColor: '#E5E5E5',
    buttonStyle: 'solid',
    logoText: 'LUXVONO',
    logoUrl: '',
    homepageBanner: '',
    storeTagline: 'Discover luxury in motion.',
    featuredProductIds: [],
    categoryHighlights: [],
    videoSectionTitle: 'VIDEO COMMERCE',
    trustMessage: 'Secure checkout, global delivery, and dedicated concierge support.',
    heroType: 'slideshow',
    homepageVideoEnabled: false,
    homepageVideoUrl: '',
    animatedBackground: '',
    heroSlideshowImages: [],
    storyCategoriesEnabled: true,
    freeShippingWorldwideEnabled: true,
    storyCategoriesLimit: 8,
    storyCategories: [],
    showPromoStrip: false,
    heroImageEnabled: true,
    heroVideoEnabled: true,
    heroSlideshowEnabled: false,
    recommendationMode: 'same-category-first',
    recommendationMinSameCategory: 4,
    recommendationNearbyCategoryWindow: 2,
    enableDarkMode: false,
    darkModeDefault: 'light',
    glassOpacity: 0.72,
    btnBg: '#111111',
    btnText: '#ffffff',
    navBg: 'rgba(255, 255, 255, 0.72)',
    navText: '#111111',
    footerBg: '#090a0f',
    footerText: '#e5e7eb',
    cardBg: 'rgba(255, 255, 255, 0.72)',
    cardBorder: 'rgba(255, 255, 255, 0.7)',
    customShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.06)',
    customBorderColor: '#E5E5E5',
    fontFamily: 'Inter, Cairo, sans-serif',
    radiusLg: '24px',
    radiusMd: '16px',
    spacingUnit: '24px',
    transitionSpeed: '0.3s',
    socialMedia: {
        tiktok: '',
        facebook: '',
        instagram: '',
        whatsapp: '',
        twitter: '',
        youtube: '',
        snapchat: '',
        telegram: '',
        linkedin: '',
        pinterest: '',
        email: '',
        phone: ''
    },
    contactDetails: {
        email: '',
        phone: '',
        address: '',
        supportHours: ''
    },
    pages: [],
    homepageSections: [],
    contactPageEnabled: true,
    contactFormRecipient: '',
    supplierName: 'LUXVONO',
    supplierYears: 5,
    supplierCountry: '',
    supplierRating: '4.9/5',
    supplierOnTimeDelivery: '99.5%',
    supplierResponseTime: '< 1h',
    supplierCustomLogo: true,
    supplierCustomPackaging: true,
    welcomeVoucherEnabled: true,
    welcomeVoucherAmount: '50$',
    welcomeVoucherTitleAr: 'باقة قسائم VIP',
    welcomeVoucherTitleEn: 'VIP COUPON PACK',
    welcomeVoucherSubtitleAr: 'قسيمة خصم ترحيبية فورية',
    welcomeVoucherSubtitleEn: 'Instant Welcome Discount Voucher',
    welcomeVoucherBtnTextAr: 'احصل عليها 🎁',
    welcomeVoucherBtnTextEn: 'GET NOW 🎁',
    welcomeVoucherCode: 'LUXVONO50',
    welcomeVoucherLink: '',
    welcomeVoucherStyle: 'gold-metallic',
    coupons: [
        {
            id: 'coupon_welcome_10',
            code: 'WELCOME10',
            titleAr: 'خصم الترحيب 10% للعملاء الجدد',
            titleEn: 'Welcome 10% Off New Customers',
            descriptionAr: 'خصم ترحيبي 10% على الطلبات المؤهلة بقيمة 100$ أو أكثر',
            descriptionEn: 'Welcome discount of 10% on orders of $100 or more',
            discountType: 'PERCENTAGE',
            discountValue: 10,
            maxDiscountCap: null,
            minOrderAmount: 100,
            targetAudience: 'ALL',
            targetCustomerEmails: [],
            targetCustomerIds: [],
            targetCustomerPhones: [],
            targetScope: 'ALL_PRODUCTS',
            targetCategoryIds: [],
            targetProductIds: [],
            startDate: '2026-02-27T00:00:00Z',
            endDate: '2027-02-27T23:59:59Z',
            usageLimit: 1000,
            usageCount: 0,
            perUserLimit: 1,
            active: true,
            badgeText: 'WELCOME DEAL',
            stylePreset: 'gold-metallic'
        }
    ]
};

const normalizeStringList = (value) => {
    if (Array.isArray(value)) {
        return value
            .map(v => String(v || '').trim())
            .filter(Boolean);
    }
    if (typeof value !== 'string') return [];
    return value
        .split(',')
        .map(v => v.trim())
        .filter(Boolean);
};

const normalizeNumberList = (value) => {
    return normalizeStringList(value)
        .map(v => Number(v))
        .filter(v => Number.isInteger(v) && v > 0);
};

const normalizeStoryCategories = (value) => {
    if (!Array.isArray(value)) return [];
    return value
        .map((item, index) => {
            const source = item && typeof item === 'object' ? item : {};
            const id = Number(source.id ?? source.categoryId ?? 0);
            if (!Number.isInteger(id) || id <= 0) return null;
            return {
                id,
                name: String(source.name || source.categoryName || ''),
                enabled: source.enabled !== false,
                order: Number.isFinite(Number(source.order)) ? Number(source.order) : index
            };
        })
        .filter(Boolean)
        .sort((a, b) => a.order - b.order);
};

const normalizeSlug = (value, fallback = '') => {
    const raw = String(value || fallback || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s-_]/g, '')
        .replace(/[\s_]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    return raw || fallback || '';
};

const normalizeHorizontalSections = (value) => {
    if (!Array.isArray(value)) return [];
    return value
        .map((section, index) => {
            const source = section && typeof section === 'object' ? section : {};
            return {
                id: String(source.id || `section_${index + 1}`),
                title: String(source.title || `Section ${index + 1}`),
                source: String(source.source || 'recommended'),
                enabled: source.enabled !== false,
                rowCount: Math.min(3, Math.max(1, Number(source.rowCount) || 1)),
                categories: normalizeStringList(source.categories)
            };
        })
        .filter(section => section.title.trim().length > 0);
};

const normalizeCmsPages = (value) => {
    if (!Array.isArray(value)) return [];
    return value
        .map((page, index) => {
            const source = page && typeof page === 'object' ? page : {};
            const title = String(source.title || `Page ${index + 1}`).trim();
            const slug = normalizeSlug(source.slug, normalizeSlug(title, `page-${index + 1}`));
            return {
                id: String(source.id || `page_${index + 1}`),
                title: title || `Page ${index + 1}`,
                title_ar: String(source.title_ar || ''),
                title_en: String(source.title_en || ''),
                slug,
                content: String(source.content || ''),
                content_ar: String(source.content_ar || ''),
                content_en: String(source.content_en || ''),
                imageUrl: String(source.imageUrl || ''),
                visibility: String(source.visibility || (source.visible === false ? 'hidden' : 'public')).toLowerCase() === 'hidden'
                    ? 'hidden'
                    : 'public',
                visible: String(source.visibility || '').toLowerCase() !== 'hidden' && source.visible !== false,
                linkType: String(source.linkType || 'none'),
                linkId: String(source.linkId || '')
            };
        })
        .filter(page => page.slug && page.title);
};

const normalizeSectionRecursive = (section, index) => {
    if (!section || typeof section !== 'object') return null;
    const typeRaw = String(section.type || (section.source ? 'products' : 'products')).toLowerCase();
    const validTypes = [
        'featured-products', 'trending', 'flash-sale', 'recommended', 
        'best-sellers', 'new-arrivals', 'recently-viewed', 'ai-recommended', 
        'custom-manual', 'horizontal-rail', 'grid-products', 'luxury-brands', 
        'video-commerce', 'categories-slider', 'banner-section', 'promo-cards',
        'products', 'categories', 'videos', 'custom-banner', 'nested-container',
        'sponsored', 'category-groups', 'category_groups',
        '3d-showcase', 'three_d_showcase', '3d_spatial',
        'motion-spotlight', 'motion_spotlight', 'marquee-products', 'marquee_products', 'dhgate-hero', 'dhgate_hero'
    ];
    const type = validTypes.includes(typeRaw) ? typeRaw : 'featured-products';

    const subSectionsRaw = Array.isArray(section.subSections) ? section.subSections : [];
    const subSections = subSectionsRaw
        .map((sub, i) => normalizeSectionRecursive(sub, i))
        .filter(Boolean)
        .sort((a, b) => a.order - b.order);

    return {
        id: String(section.id || `home_section_${index + 1}_${Math.floor(Math.random() * 100000)}`),
        title: String(section.title || `Section ${index + 1}`),
        titleAr: String(section.titleAr || ''),
        titleEn: String(section.titleEn || ''),
        descAr: String(section.descAr || ''),
        descEn: String(section.descEn || ''),
        imageUrl: String(section.imageUrl || section.bannerImage || ''),
        videoUrl: String(section.videoUrl || ''),
        iconClass: String(section.iconClass || ''),
        customColor: String(section.customColor || ''),
        customBackground: String(section.customBackground || ''),
        customGradient: String(section.customGradient || ''),
        glassEffect: section.glassEffect === true,
        blurIntensity: String(section.blurIntensity || '16px'),
        glassOpacity: Number.isFinite(Number(section.glassOpacity)) ? Number(section.glassOpacity) : 0.72,
        cardHoverStyle: String(section.cardHoverStyle || 'scale'),
        customBorderColor: String(section.customBorderColor || 'glass'),
        luxuryHighlights: section.luxuryHighlights === true,
        
        layoutType: String(section.layoutType || 'grid'),
        imageRatioMode: String(section.imageRatioMode || 'auto'),
        imageRatio: String(section.imageRatio || '4/5'),
        cardLayout: String(section.cardLayout || 'vertical'),
        productLimit: Number.isFinite(Number(section.productLimit)) ? Number(section.productLimit) : 8,
        rowCount: Math.min(6, Math.max(1, Number(section.rowCount) || 1)),
        columnsMobile: Math.min(4, Math.max(1, Number(section.columnsMobile) || 2)),
        columnsTablet: Math.min(6, Math.max(1, Number(section.columnsTablet) || 3)),
        columnsDesktop: Math.min(12, Math.max(1, Number(section.columnsDesktop) || 4)),
        videoAutoplay: section.videoAutoplay !== false,
        paddingTop: String(section.paddingTop || '0px'),
        paddingBottom: String(section.paddingBottom || '0px'),
        gap: String(section.gap || '24px'),

        badgeFire: section.badgeFire === true,
        badgeDiscount: section.badgeDiscount === true,
        badgeLightning: section.badgeLightning === true,
        badgeLuxury: section.badgeLuxury === true,
        badgeFreeShipping: section.badgeFreeShipping === true,
        badgeVerified: section.badgeVerified === true,
        badgeAIRecommended: section.badgeAIRecommended === true,

        specialDiscountEnabled: section.specialDiscountEnabled === true,
        specialDiscountValue: String(section.specialDiscountValue || ''),
        limitedStockEnabled: section.limitedStockEnabled === true,
        limitedStockValue: Number.isFinite(Number(section.limitedStockValue)) ? Number(section.limitedStockValue) : 5,
        urgencyBadgeEnabled: section.urgencyBadgeEnabled === true,
        urgencyBadgeType: String(section.urgencyBadgeType || 'hot-deal'),
        timerEnabled: section.timerEnabled === true,
        timerEndTime: String(section.timerEndTime || ''),

        targetPage: String(section.targetPage || 'home-page'),
        pagePosition: String(section.pagePosition || 'bottom'),
        afterProductIndex: Number.isFinite(Number(section.afterProductIndex)) ? Number(section.afterProductIndex) : 4,
        enabled: section.enabled !== false,
        order: Number.isFinite(Number(section.order)) ? Number(section.order) : index,
        publishStart: String(section.publishStart || ''),
        publishEnd: String(section.publishEnd || ''),
        mobileOnly: section.mobileOnly === true,
        desktopOnly: section.desktopOnly === true,
        targetCountries: normalizeStringList(section.targetCountries),
        targetLanguages: normalizeStringList(section.targetLanguages),
        targetUsers: String(section.targetUsers || 'all'),

        source: String(section.source || 'recommended'),
        categories: normalizeStringList(section.categories),
        categoryIds: normalizeNumberList(section.categoryIds),
        productIds: normalizeNumberList(section.productIds),
        videoIds: normalizeNumberList(section.videoIds),
        subSections,

        bannerImage: String(section.bannerImage || section.imageUrl || ''),
        bannerTitle: String(section.bannerTitle || ''),
        bannerSubtitle: String(section.bannerSubtitle || ''),
        bannerLink: String(section.bannerLink || section.linkUrl || ''),

        categoryGroupStyle: String(section.categoryGroupStyle || 'editorial'),
        heroImageUrl: String(section.heroImageUrl || ''),
        collectionBadge: String(section.collectionBadge || ''),

        stylePreset: String(section.stylePreset || 'royal-gold'),
        cardTilt3d: section.cardTilt3d === true,
        threeDModelType: String(section.threeDModelType || 'luxury-watch'),
        glbUrl: String(section.glbUrl || ''),
        usdzUrl: String(section.usdzUrl || ''),
        lightingPreset: String(section.lightingPreset || 'studio'),
        autoRotate3d: section.autoRotate3d !== false,
        showArBadge: section.showArBadge !== false,
        showcaseTag: String(section.showcaseTag || '3D SPATIAL COMMERCE'),
        showcaseActionUrl: String(section.showcaseActionUrl || ''),
        showcaseActionText: String(section.showcaseActionText || ''),

        // Motion, Spotlight & Animation Fields (DHgate & Global Portal Style)
        motionEnabled: section.motionEnabled === true,
        motionType: String(section.motionType || 'infinite-marquee'),
        motionSpeed: String(section.motionSpeed || 'normal'),
        pauseOnHover: section.pauseOnHover !== false,
        spotlightVideoUrl: String(section.spotlightVideoUrl || ''),
        spotlightBadgeText: String(section.spotlightBadgeText || ''),
        spotlightActionUrl: String(section.spotlightActionUrl || ''),
        spotlightActionText: String(section.spotlightActionText || ''),
        spotlightMediaSide: String(section.spotlightMediaSide || 'left')
    };
};

const normalizeHomepageSections = (value, fallbackHorizontalSections = []) => {
    const sourceList = Array.isArray(value) && value.length > 0 ? value : fallbackHorizontalSections;
    if (!sourceList || !Array.isArray(sourceList)) return [];
    return sourceList
        .map((sec, i) => normalizeSectionRecursive(sec, i))
        .filter(Boolean)
        .sort((a, b) => a.order - b.order);
};


const normalizeCoupons = (value) => {
    if (!Array.isArray(value)) return DEFAULT_STOREFRONT_SETTINGS.coupons || [];
    return value.map((item, index) => {
        if (!item || typeof item !== 'object') return null;
        const code = String(item.code || `PROMO${index + 1}`).trim().toUpperCase();
        if (!code) return null;
        return {
            id: String(item.id || `coupon_${Date.now()}_${index}`),
            code,
            titleAr: String(item.titleAr || item.title || code),
            titleEn: String(item.titleEn || item.title || code),
            descriptionAr: String(item.descriptionAr || item.description || ''),
            descriptionEn: String(item.descriptionEn || item.description || ''),
            discountType: ['PERCENTAGE', 'FIXED_AMOUNT', 'FREE_SHIPPING'].includes(String(item.discountType).toUpperCase())
                ? String(item.discountType).toUpperCase()
                : 'FIXED_AMOUNT',
            discountValue: Math.max(0, Number(item.discountValue) || 0),
            maxDiscountCap: Number.isFinite(Number(item.maxDiscountCap)) && Number(item.maxDiscountCap) > 0 ? Number(item.maxDiscountCap) : null,
            minOrderAmount: Math.max(0, Number(item.minOrderAmount) || 0),
            targetAudience: ['ALL', 'VIP_ONLY', 'SPECIFIC_USERS', 'NEW_CUSTOMERS'].includes(String(item.targetAudience).toUpperCase())
                ? String(item.targetAudience).toUpperCase()
                : 'ALL',
            targetCustomerEmails: Array.isArray(item.targetCustomerEmails) ? item.targetCustomerEmails.map(e => String(e).trim().toLowerCase()).filter(Boolean) : [],
            targetCustomerIds: Array.isArray(item.targetCustomerIds) ? item.targetCustomerIds.map(id => String(id).trim()).filter(Boolean) : [],
            targetCustomerPhones: Array.isArray(item.targetCustomerPhones) ? item.targetCustomerPhones.map(p => String(p).trim()).filter(Boolean) : [],
            targetScope: ['ALL_PRODUCTS', 'SPECIFIC_CATEGORIES', 'SPECIFIC_PRODUCTS'].includes(String(item.targetScope).toUpperCase())
                ? String(item.targetScope).toUpperCase()
                : 'ALL_PRODUCTS',
            targetCategoryIds: Array.isArray(item.targetCategoryIds) ? item.targetCategoryIds.map(Number).filter(n => Number.isInteger(n) && n > 0) : [],
            targetProductIds: Array.isArray(item.targetProductIds) ? item.targetProductIds.map(Number).filter(n => Number.isInteger(n) && n > 0) : [],
            startDate: String(item.startDate || '2026-01-01T00:00:00Z'),
            endDate: String(item.endDate || '2027-12-31T23:59:59Z'),
            usageLimit: Number.isFinite(Number(item.usageLimit)) ? Math.max(1, Number(item.usageLimit)) : 100,
            usageCount: Math.max(0, Number(item.usageCount) || 0),
            perUserLimit: Number.isFinite(Number(item.perUserLimit)) ? Math.max(1, Number(item.perUserLimit)) : 1,
            active: item.active !== false,
            badgeText: String(item.badgeText || 'SPECIAL OFFER'),
            stylePreset: String(item.stylePreset || 'gold-metallic')
        };
    }).filter(Boolean);
};

export const normalizeStorefrontSettings = (rawSettings = {}) => {
    const source = rawSettings || {};
    const sanitizeColor = (c, fallback) => {
        if (!c) return fallback;
        const val = String(c).trim();
        const hexRegex = /^#([0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;
        const rgbRegex = /^rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*(?:,\s*[\d.]+\s*)?\)$/;
        const allowedNames = ['transparent', 'inherit', 'initial', 'none'];
        if (hexRegex.test(val) || rgbRegex.test(val) || allowedNames.includes(val.toLowerCase())) {
            return val;
        }
        return fallback;
    };
    const horizontalSections = normalizeHorizontalSections(source.horizontalSections);
    const homepageSections = normalizeHomepageSections(source.homepageSections, horizontalSections);
    return {
        primaryColor: sanitizeColor(source.primaryColor, DEFAULT_STOREFRONT_SETTINGS.primaryColor),
        accentColor: sanitizeColor(source.accentColor, DEFAULT_STOREFRONT_SETTINGS.accentColor),
        backgroundColor: sanitizeColor(source.backgroundColor, DEFAULT_STOREFRONT_SETTINGS.backgroundColor),
        cardColor: sanitizeColor(source.cardColor, DEFAULT_STOREFRONT_SETTINGS.cardColor),
        textColor: sanitizeColor(source.textColor, DEFAULT_STOREFRONT_SETTINGS.textColor),
        textMutedColor: sanitizeColor(source.textMutedColor, DEFAULT_STOREFRONT_SETTINGS.textMutedColor),
        borderColor: sanitizeColor(source.borderColor, DEFAULT_STOREFRONT_SETTINGS.borderColor),
        buttonStyle: String(source.buttonStyle || DEFAULT_STOREFRONT_SETTINGS.buttonStyle),
        logoText: String(source.logoText || DEFAULT_STOREFRONT_SETTINGS.logoText),
        logoUrl: String(source.logoUrl || ''),
        homepageBanner: String(source.homepageBanner || ''),
        storeTagline: String(source.storeTagline || DEFAULT_STOREFRONT_SETTINGS.storeTagline),
        featuredProductIds: normalizeNumberList(source.featuredProductIds),
        categoryHighlights: normalizeStringList(source.categoryHighlights),
        videoSectionTitle: String(source.videoSectionTitle || DEFAULT_STOREFRONT_SETTINGS.videoSectionTitle),
        trustMessage: String(source.trustMessage || DEFAULT_STOREFRONT_SETTINGS.trustMessage),
        heroType: String(source.heroType || DEFAULT_STOREFRONT_SETTINGS.heroType).toLowerCase() === 'gradient'
            ? 'animated'
            : String(source.heroType || DEFAULT_STOREFRONT_SETTINGS.heroType),
        homepageVideoEnabled: source.homepageVideoEnabled !== false,
        homepageVideoUrl: String(source.homepageVideoUrl || ''),
        animatedBackground: String(source.animatedBackground || ''),
        heroSlideshowImages: normalizeStringList(source.heroSlideshowImages),
        storyCategoriesEnabled: source.storyCategoriesEnabled !== false,
        freeShippingWorldwideEnabled: source.freeShippingWorldwideEnabled !== false,
        showPromoStrip: source.showPromoStrip === true,
        storyCategoriesLimit: Math.min(30, Math.max(1, Number(source.storyCategoriesLimit) || DEFAULT_STOREFRONT_SETTINGS.storyCategoriesLimit)),
        storyCategories: normalizeStoryCategories(source.storyCategories),
        heroImageEnabled: source.heroImageEnabled !== false,
        heroVideoEnabled: source.heroVideoEnabled !== false,
        heroSlideshowEnabled: source.heroSlideshowEnabled === true,
        recommendationMode: ['same-category-first', 'mixed-nearby-categories'].includes(String(source.recommendationMode || '').toLowerCase())
            ? String(source.recommendationMode).toLowerCase()
            : DEFAULT_STOREFRONT_SETTINGS.recommendationMode,
        recommendationMinSameCategory: Math.min(12, Math.max(1, Number(source.recommendationMinSameCategory) || DEFAULT_STOREFRONT_SETTINGS.recommendationMinSameCategory)),
        recommendationNearbyCategoryWindow: Math.min(6, Math.max(1, Number(source.recommendationNearbyCategoryWindow) || DEFAULT_STOREFRONT_SETTINGS.recommendationNearbyCategoryWindow)),
        enableDarkMode: source.enableDarkMode !== undefined ? Boolean(source.enableDarkMode) : false,
        darkModeDefault: 'light',
        glassOpacity: Number.isFinite(Number(source.glassOpacity)) ? Number(source.glassOpacity) : DEFAULT_STOREFRONT_SETTINGS.glassOpacity,
        btnBg: sanitizeColor(source.btnBg, DEFAULT_STOREFRONT_SETTINGS.btnBg),
        btnText: sanitizeColor(source.btnText, DEFAULT_STOREFRONT_SETTINGS.btnText),
        navBg: sanitizeColor(source.navBg, DEFAULT_STOREFRONT_SETTINGS.navBg),
        navText: sanitizeColor(source.navText, DEFAULT_STOREFRONT_SETTINGS.navText),
        footerBg: sanitizeColor(source.footerBg, DEFAULT_STOREFRONT_SETTINGS.footerBg),
        footerText: sanitizeColor(source.footerText, DEFAULT_STOREFRONT_SETTINGS.footerText),
        cardBg: sanitizeColor(source.cardBg, DEFAULT_STOREFRONT_SETTINGS.cardBg),
        cardBorder: sanitizeColor(source.cardBorder, DEFAULT_STOREFRONT_SETTINGS.cardBorder),
        customShadow: String(source.customShadow || DEFAULT_STOREFRONT_SETTINGS.customShadow),
        customBorderColor: String(source.customBorderColor || DEFAULT_STOREFRONT_SETTINGS.customBorderColor),
        fontFamily: String(source.fontFamily || DEFAULT_STOREFRONT_SETTINGS.fontFamily),
        radiusLg: String(source.radiusLg || DEFAULT_STOREFRONT_SETTINGS.radiusLg),
        radiusMd: String(source.radiusMd || DEFAULT_STOREFRONT_SETTINGS.radiusMd),
        spacingUnit: String(source.spacingUnit || DEFAULT_STOREFRONT_SETTINGS.spacingUnit),
        transitionSpeed: String(source.transitionSpeed || DEFAULT_STOREFRONT_SETTINGS.transitionSpeed),
        horizontalSections,
        homepageSections,
        socialMedia: {
            tiktok: String(source.socialMedia?.tiktok || ''),
            facebook: String(source.socialMedia?.facebook || ''),
            instagram: String(source.socialMedia?.instagram || ''),
            whatsapp: String(source.socialMedia?.whatsapp || ''),
            twitter: String(source.socialMedia?.twitter || source.socialMedia?.x || ''),
            youtube: String(source.socialMedia?.youtube || ''),
            snapchat: String(source.socialMedia?.snapchat || ''),
            telegram: String(source.socialMedia?.telegram || ''),
            linkedin: String(source.socialMedia?.linkedin || ''),
            pinterest: String(source.socialMedia?.pinterest || ''),
            email: String(source.socialMedia?.email || ''),
            phone: String(source.socialMedia?.phone || '')
        },
        contactDetails: {
            email: String(source.contactDetails?.email || ''),
            phone: String(source.contactDetails?.phone || ''),
            address: String(source.contactDetails?.address || ''),
            supportHours: String(source.contactDetails?.supportHours || '')
        },
        pages: normalizeCmsPages(source.pages),
        contactPageEnabled: source.contactPageEnabled !== false,
        contactFormRecipient: String(source.contactFormRecipient || ''),
        supplierName: String(source.supplierName || DEFAULT_STOREFRONT_SETTINGS.supplierName),
        supplierYears: Number.isFinite(Number(source.supplierYears)) ? Number(source.supplierYears) : DEFAULT_STOREFRONT_SETTINGS.supplierYears,
        supplierCountry: String(source.supplierCountry || DEFAULT_STOREFRONT_SETTINGS.supplierCountry),
        supplierRating: String(source.supplierRating || DEFAULT_STOREFRONT_SETTINGS.supplierRating),
        supplierOnTimeDelivery: String(source.supplierOnTimeDelivery || DEFAULT_STOREFRONT_SETTINGS.supplierOnTimeDelivery),
        supplierResponseTime: String(source.supplierResponseTime || DEFAULT_STOREFRONT_SETTINGS.supplierResponseTime),
        supplierCustomLogo: source.supplierCustomLogo !== false,
        supplierCustomPackaging: source.supplierCustomPackaging !== false,
        welcomeVoucherEnabled: source.welcomeVoucherEnabled !== undefined ? Boolean(source.welcomeVoucherEnabled) : DEFAULT_STOREFRONT_SETTINGS.welcomeVoucherEnabled,
        welcomeVoucherAmount: String(source.welcomeVoucherAmount || DEFAULT_STOREFRONT_SETTINGS.welcomeVoucherAmount),
        welcomeVoucherTitleAr: String(source.welcomeVoucherTitleAr || DEFAULT_STOREFRONT_SETTINGS.welcomeVoucherTitleAr),
        welcomeVoucherTitleEn: String(source.welcomeVoucherTitleEn || DEFAULT_STOREFRONT_SETTINGS.welcomeVoucherTitleEn),
        welcomeVoucherSubtitleAr: String(source.welcomeVoucherSubtitleAr || DEFAULT_STOREFRONT_SETTINGS.welcomeVoucherSubtitleAr),
        welcomeVoucherSubtitleEn: String(source.welcomeVoucherSubtitleEn || DEFAULT_STOREFRONT_SETTINGS.welcomeVoucherSubtitleEn),
        welcomeVoucherBtnTextAr: String(source.welcomeVoucherBtnTextAr || DEFAULT_STOREFRONT_SETTINGS.welcomeVoucherBtnTextAr),
        welcomeVoucherBtnTextEn: String(source.welcomeVoucherBtnTextEn || DEFAULT_STOREFRONT_SETTINGS.welcomeVoucherBtnTextEn),
        welcomeVoucherCode: String(source.welcomeVoucherCode || DEFAULT_STOREFRONT_SETTINGS.welcomeVoucherCode),
        welcomeVoucherLink: String(source.welcomeVoucherLink || ''),
        welcomeVoucherStyle: String(source.welcomeVoucherStyle || DEFAULT_STOREFRONT_SETTINGS.welcomeVoucherStyle),
        coupons: normalizeCoupons(source.coupons)
    };
};
